import { msg } from "@lingui/core/macro";
import { Card, CardContent, CardHeader, CardTitle } from "@fleet/ui";
import { useI18n } from "@/providers/i18n-provider";
import { BarChart3, Briefcase, CheckCircle2, Clock, Flame } from "@fleet/icons";

interface StatsSectionProps {
  userId: string;
}

export function StatsSection(_props: StatsSectionProps) {
  const { t } = useI18n();

  return (
    <Card class="border-white/10 bg-[#121212]">
      <CardHeader>
        <div class="flex items-center gap-2">
          <BarChart3 class="h-5 w-5 text-[#afc6ff]" />
          <CardTitle class="text-sm font-bold text-foreground uppercase tracking-wider">
            {t(msg`Productivity Stats`)}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent class="space-y-6">
        <div class="grid grid-cols-2 gap-4 sm:grid-cols-4">
          <div class="flex flex-col items-center justify-center rounded-2xl p-4 text-center bg-white/5 border border-white/5">
            <Clock class="h-5 w-5 text-[#ebb2ff] mb-2" />
            <span class="text-2xl font-black leading-none tracking-tight text-[#ebb2ff]">
              18.4h
            </span>
            <div class="mt-2 text-[9px] font-bold text-muted-foreground uppercase tracking-widest opacity-80 select-none">
              {t(msg`Tracked Time`)}
            </div>
          </div>

          <div class="flex flex-col items-center justify-center rounded-2xl p-4 text-center bg-white/5 border border-white/5">
            <Flame class="h-5 w-5 text-amber-500 mb-2" />
            <span class="text-2xl font-black leading-none tracking-tight text-amber-500">12</span>
            <div class="mt-2 text-[9px] font-bold text-muted-foreground uppercase tracking-widest opacity-80 select-none">
              {t(msg`Focus Cycles`)}
            </div>
          </div>

          <div class="flex flex-col items-center justify-center rounded-2xl p-4 text-center bg-white/5 border border-white/5">
            <Briefcase class="h-5 w-5 text-sky-400 mb-2" />
            <span class="text-2xl font-black leading-none tracking-tight text-sky-400">4</span>
            <div class="mt-2 text-[9px] font-bold text-muted-foreground uppercase tracking-widest opacity-80 select-none">
              {t(msg`Active Projects`)}
            </div>
          </div>

          <div class="flex flex-col items-center justify-center rounded-2xl p-4 text-center bg-white/5 border border-white/5">
            <CheckCircle2 class="h-5 w-5 text-emerald-500 mb-2" />
            <span class="text-2xl font-black leading-none tracking-tight text-emerald-500">28</span>
            <div class="mt-2 text-[9px] font-bold text-muted-foreground uppercase tracking-widest opacity-80 select-none">
              {t(msg`Tasks Done`)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
